<template>
    <div>
        <!-- cart_block -->
        <div class="row cart_block mt_sm">
            <div class="col-12">
                <div class="info_title cart_group_title">
                    Выберите <b>способ оплаты</b>.
                </div>
                <div class="info_body">
                    <div class="form-inline ki_options">
                        <input
                            class="form-control info_body_selected"
                            :class="{ 'is-invalid': errors.payment }"
                            v-model="payment.name"
                            readonly
                        />
                        <button type="button" class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalPayment">
                            Выбрать способ оплаты
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //cart_block -->

        <order-form-payment-method-modal></order-form-payment-method-modal>
    
    </div>
</template>

<script>
import OrderFormPaymentMethodModal from './OrderFormPaymentMethodModal.vue';
export default {
    components: { OrderFormPaymentMethodModal },
    methods: {},
    computed: {
        // Выбранный способ оплаты
        payment() {
            return this.$store.state.order.payment;
        },
        errors() {
            return this.$store.state.order.errors;
        },
    },
    mounted() {
        this.$store.dispatch('payment/getPayments');
    }
};
</script>
